// bibliography — the boundary reader for a source's own title, author(s)
// and year, as the server projects them (`GET /state` library rows,
// `showResource`'s `resource.summary.bibliography`). Pure and total:
// anything malformed (absent, an older server, shape drift) reads as
// `undefined`, so the row or header simply shows no author line.

export { parseBibliography };

import type { SourceBibliography } from "./ports/workspace.js";
import { fields, list, num, str } from "./wireShape.js";

const parseBibliography = (raw: unknown): SourceBibliography | undefined => {
    const f = fields(raw);
    const title = str(f?.get("title"));
    if (title === undefined || title.trim() === "") return undefined;
    const authors = list(f?.get("authors")).flatMap((a) => {
        const s = str(a);
        return s === undefined || s.trim() === "" ? [] : [s];
    });
    const year = num(f?.get("year"));
    return year === undefined
        ? { title, authors }
        : { title, authors, year: Math.trunc(year) };
};
